import './audio_waveform_component.js';

class AudioPlayerComponent extends HTMLElement {
  connectedCallback() {
    this.initPlayerEvents();
    this.initUserEvents();
  }

  get audio() {
    return this.querySelector('audio');
  }

  get track() {
    return this.querySelector('track');
  }

  get playButton() {
    return this.querySelector('[data-play-button]');
  }

  get pauseButton() {
    return this.querySelector('[data-pause-button]');
  }

  get captionsContainer() {
    return this.querySelector('[data-captions-container]');
  }

  initPlayerEvents() {
    if (this.audio.readyState >= 1) {
      this.initClosedCaptions();
    } else {
      this.audio.addEventListener('loadedmetadata', () => {
        this.initClosedCaptions();
      });
    }

    this.audio.addEventListener('ended', () => this.resetToStart());

    window.addEventListener('tmpaudioplay', (e) => {
      if (e.target !== this) {
        this.pauseAudio();
      }
    });
  }

  initUserEvents() {
    this.playButton.addEventListener('click', () => this.togglePlay());
    this.pauseButton.addEventListener('click', () => this.togglePlay());
  }

  initClosedCaptions() {
    this.audio.textTracks[0].mode = 'hidden';

    this.audio.textTracks[0].addEventListener('cuechange', (e) => {
      if (e.target.activeCues.length > 0) {
        this.captionsContainer.innerHTML = e.target.activeCues[0].text;
      } else {
        this.captionsContainer.innerHTML = '';
      }
    });
  }

  togglePlay() {
    if (this.audio.paused) {
      this.playAudio();
    } else {
      this.pauseAudio();
    }
  }

  playAudio() {
    this.audio.play();
    this.playButton.style.display = 'none';
    this.pauseButton.style.display = 'block';

    const playEvent = new CustomEvent('tmpaudioplay', {
      bubbles: true,
    });
    this.dispatchEvent(playEvent);
  }

  pauseAudio() {
    this.audio.pause();
    this.pauseButton.style.display = 'none';
    this.playButton.style.display = 'block';
  }

  resetToStart() {
    this.pauseAudio();
    this.audio.currentTime = 0;
  }
}

if (!window.customElements.get('tmp-audio-player')) {
  window.AudioPlayerComponent = AudioPlayerComponent;
  window.customElements.define('tmp-audio-player', AudioPlayerComponent);
}
